import { CalcDiscount } from "./calcDiscount";

export function InvoiceData(
  newId,
  productId,
  barcode,
  title,
  pricing,
  quantity,
  measuring_unit,
  discount,
  inventory
) {

  const qty = Number(quantity) || 0;

  let total = CalcDiscount(discount, quantity, pricing);
  
  if(!total.success) {
    return false;
  }

  total = Math.round(total.result * 100) / 100;
  const data = {
    id: newId,
    prod_id: productId,
    barcode,
    name: title,
    price: pricing,
    quantity: qty,
    measure: measuring_unit,
    discount,
    amount: total,
    amountFormatted: total.toFixed(2),
    inventory
  };

  return data;
}
